import {Injectable, Signal} from '@angular/core';
import {TrialInfo, UserInfoState} from './user-info.type';
import {Observable} from 'rxjs';
import {userInfoStore} from './user-info.store';
import {select} from '@ngneat/elf';
import {toSignal} from '@angular/core/rxjs-interop';

@Injectable({providedIn: 'root'})
export class UserInfoQuery {
  public userInfo$: Observable<UserInfoState>;
  public trialInfo: Signal<TrialInfo>;

  constructor() {
    this.userInfo$ = userInfoStore.pipe(select(state => state.userInfo));
    this.trialInfo = toSignal(userInfoStore.pipe(select(state => state.userInfo.trialInfo)));
  }
}
